import React from 'react';
import {PropTypes} from 'prop-types';
import {ButtonOverlay} from '@homeaway/react-buttons';
import './OnboardingGuideModal.less';

class OnboardingButtons extends React.Component {
    static propTypes = {
        onPrimary: PropTypes.func.isRequired,
        onSecondary: PropTypes.func,
        primaryText: PropTypes.string.isRequired,
        secondaryText: PropTypes.string,
    };
    constructor(props) {
        super(props);
    }

    _onClickSecondary(buttonClicked, buttonName) {
        this.props.onSecondary(buttonClicked, buttonName);
    }

    _onClickPrimary(buttonClicked, buttonName) {
        this.props.onPrimary(buttonClicked, buttonName);
    }

    render() {
        const props = this.props;
        return (
            <div className="OnboardingNextSkipDoneButtons">
                {props.primaryText && (
                    <ButtonOverlay
                        className="OnboardingNextButton"
                        size="xs"
                        label={props.primaryText}
                        onClick={() => this._onClickPrimary(true, 'NEXT')}
                    />
                )}
                {props.secondaryText && (
                    <ButtonOverlay
                        className="OnboardingSkipButton"
                        label={props.secondaryText}
                        size="xs"
                        onClick={() => this._onClickSecondary(true, 'SKIP')}
                    />
                )}
            </div>
        );
    }
}

export default OnboardingButtons;
